import { fetchEventSource } from "@microsoft/fetch-event-source";
import cookie from "../js/CookieUtil"
import { cookieTypes } from "./Types"
import Urls from "./Urls";
import Utils from "./Utils";
const controller = new AbortController();
type Callback = (reslut:any)=>void;
async function fetchRequest(ask:string,seesonID:string,think:Callback,reply:Callback,error:Callback):Promise<any>{
    const data={
        prompt:ask,
        sessionId:seesonID
    }
    const requestData={
        token: cookie.getCookie(cookieTypes.XC_COOKIES_ACCESSTOKEN)||"",
        projectSid:cookie.getCookie(cookieTypes.XC_COOKIES_PROJECTSID)||"",
        data: data
    }
     await fetchEventSource(Utils.GetBaseUrl()+ Urls.AiAsk,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
        signal: controller.signal, // 绑定中断信号
        openWhenHidden: true,      // 页面隐藏时保持连接[7](@ref)

        // 连接成功回调
        onopen: async (response) => {
            if (response.status !== 200) {
                throw new Error(`连接失败：${response.status}`);
            }
            console.log("SSE 连接已建立");
        },

        // 接收消息回调
        onmessage: (event) => {
            // console.log(event);
            // console.log(event.data);
            const obj = JSON.parse(event.data);
            // console.log(obj);
            //发生异常
            if(obj.type=="thought"){
                if(obj.payload.procedures&&obj.payload.procedures.length>0){
                    obj.payload.procedures.forEach((d:any) => {
                        think(d.debugging.content);
                    });
                }
            }
            if(obj.type=="reply"){
                reply(obj.payload.content);
            }
            if (obj.type === "error") {
                console.log(obj.payload);
                error(obj.payload);
            }
            //请求已完成
            if (obj.type === "system" && obj.payload === "[DONE]") {
                controller.abort(); // 收到结束标志时中断请求
                console.log("请求已完成！");
                error(-1);
            }
        },
        // 错误处理
        onerror: (err) => {
            console.error("请求异常：", err);
            controller.abort();
            throw err; // 必须抛出错误以阻止重试[1,5](@ref)
        }
    })
}
export default {
    fetchRequest: fetchRequest
}